import { inject, injectable } from 'inversify';
import Request from '@/Framework/api/Rpc/Request';
import RpcDispatcher from '@/finsight/application/DI/Rpc/finsight-strats/HttpDispatcher';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';

@injectable()
class StratsRepository {
  constructor(@inject(RpcDispatcher) protected readonly rpc: typeof RpcDispatcher) {}

  getMetadata = async (fileId: number) => {
    const request = new Request('finsight_strats.filings.get_metadata_by_file_id', { fileId });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  getGroups = async (fileId: number) => {
    const request = new Request('finsight_strats.filings.get_groups_by_file_id', { fileId });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  getSummaryByFilters = async (fileId: number, rangeExcludedIds: number[] = []) => {
    const request = new Request('finsight_strats.filings.get_filter_summary_by_file_id', {
      fileId, filters: { rangeExcludedIds },
    });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  getStratsByGroupId = async (fileId: number, groupId: number, rangeExcludedIds: number[] = []) => {
    const request = new Request('finsight_strats.filings.get_strats_by_file_id_group_id', {
      fileId, groupId, filters: { rangeExcludedIds },
    });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  getStratsByGroupIds = async (fileId: number, groupId: number, rangeExcludedIds: number[] = []) => {
    const request = new Request('finsight_strats.filings.get_strats_by_file_id_group_ids', {
      fileId, groupId, filters: { rangeExcludedIds },
    });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  getSidebarMetadata = async (fileId: number) => {
    const request = new Request('finsight_strats.filings.get_powerbar_metadata_by_file_id', { fileId });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  getSidebarGroups = async (fileId: number) => {
    const request = new Request('finsight_strats.filings.get_powerbar_groups_by_file_id', { fileId });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };
}

export default StratsRepository;
